import { useTheme } from '@ytl/common-web';
import { useLayoutEffect } from 'react';
import { LockoutView } from '../modules/migra/LockoutView';
import { LockoutWebView } from '../modules/migra/LockoutWebView';
import { MigrationProvider } from '../modules/migra/service/MigrationContext';

export const LockoutPage = () => {
  const { isWebView } = useTheme();

  // Lockout oldal ugyanazokat a class-okat használja mint a MigraFirstPage Intro képernyője:
  // - register-page: footer/gradient alap styling
  // - migra-first-page-root: fehér háttér, gradient elrejtve
  // - ytl--app: webview-ban elrejti a headert
  useLayoutEffect(() => {
    document.documentElement.classList.add('register-page');
    document.documentElement.classList.add('migra-first-page-root');
    if (isWebView) {
      document.documentElement.classList.add('ytl--app');
    }

    return () => {
      document.documentElement.classList.remove('register-page');
      document.documentElement.classList.remove('migra-first-page-root');
      document.documentElement.classList.remove('ytl--app');
    };
  }, [isWebView]);

  return <MigrationProvider>{isWebView ? <LockoutWebView /> : <LockoutView />}</MigrationProvider>;
};
